'use client';

import { trackCTA } from '@/lib/analytics';
import { Button } from '@/components/ui/Button';

type CtaBannerProps = {
  title: string;
  description?: string;
  ctaLabel: string;
  ctaHref: string;
  variant?: 'default' | 'dark';
};

export default function CtaBanner({
  title,
  description,
  ctaLabel,
  ctaHref,
  variant = 'default',
}: CtaBannerProps) {
  const handleCTAClick = () => {
    trackCTA('primary', 'cta-banner');
  };

  return (
          <section
      className={`relative py-12 sm:py-xl ${variant === 'dark' ? 'bg-panel' : 'grad-2'} overflow-hidden`}
      aria-labelledby="cta-banner-title"
    >
      {/* Dark overlay for text contrast if using gradient */}
      {variant !== 'dark' && <div className="absolute inset-0 bg-black/20" aria-hidden="true" />}
      
      <div className="container relative z-10 px-4 sm:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2
            id="cta-banner-title"
            className={`text-2xl sm:text-3xl md:text-4xl font-bold mb-4 sm:mb-md ${
              variant === 'dark' ? 'text-text' : 'text-white'
            }`}
          >
            {title}
          </h2>
          
          {description && (
            <p
              className={`text-base sm:text-lg mb-6 sm:mb-lg px-4 sm:px-0 ${
                variant === 'dark' ? 'text-muted' : 'text-white/90'
              }`}
            >
              {description}
            </p>
          )}
          
          <Button
            variant={variant === 'dark' ? 'primary' : 'secondary'}
            size="lg"
            asChild
            href={ctaHref}
            onClick={handleCTAClick}
            className={`text-sm sm:text-base px-4 sm:px-6 py-2.5 sm:py-3 ${variant === 'dark' ? '' : '!bg-white !text-red-engineering hover:!bg-white/90 !border-white'}`}
          >
            {ctaLabel}
          </Button>
        </div>
      </div>
    </section>
  );
}